/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Apartment_Checkin_FromInputs */

const en_apartment_checkin_from = /** @type {(inputs: Apartment_Checkin_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check-in from ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Check-in from {time}" |
*
* @param {Apartment_Checkin_FromInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const apartment_checkin_from = /** @type {((inputs: Apartment_Checkin_FromInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apartment_Checkin_FromInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_apartment_checkin_from(inputs)
});